export default {
  dict: {
    title: 'dict service manage'
  }
}



// WEBPACK FOOTER //
// ./src/local/lang/sys/dict/en-US-dict.js